module.exports = __webpack_public_path__ + "img/poster_count_gb.7a5505ad.png";